 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML00_COVER from '@/components/xhtml/00_Cover'
 import XHTML01_TITLE_PAGE from '@/components/xhtml/01_Title_Page'
 import XHTML02_COPYRIGHT from '@/components/xhtml/02_Copyright'
 import XHTML03_DEDICATION from '@/components/xhtml/03_Dedication'
 import XHTML04_CONTENTS from '@/components/xhtml/04_Contents'
 import XHTML05_ACKNOWLEDGMENTS from '@/components/xhtml/05_Acknowledgments'
 import XHTML06_AUTHOR_S_NOTES from '@/components/xhtml/06_Author_s_Notes'
 import XHTML07_INTRODUCTION from '@/components/xhtml/07_Introduction'
 import XHTML08_1__SEX_IN_GRAY_SPACES from '@/components/xhtml/08_1__Sex_in_Gray_Spaces'
 import XHTML09_2__FIRST_TIMERS_WELCOME from '@/components/xhtml/09_2__First_Timers_Welcome'
 import XHTML10_3__STIGMA_AND_THE_MORAL_ECONOMY from '@/components/xhtml/10_3__Stigma_and_the_Moral_Economy'
 import XHTML11_4__HEALING_CUSTOMERS from '@/components/xhtml/11_4__Healing_Customers'
 import XHTML12_5__VICTIMS_ALL from '@/components/xhtml/12_5__Victims_All'
 import XHTML13_6__RISK_AND_RIGHTS from '@/components/xhtml/13_6__Risk_and_Rights'
 import XHTML14_EPILOGUE from '@/components/xhtml/14_Epilogue'
 import XHTML15_NOTES from '@/components/xhtml/15_Notes'
 import XHTML16_GLOSSARY from '@/components/xhtml/16_Glossary'
 import XHTML17_BIBLIOGRAPHY from '@/components/xhtml/17_Bibliography'
 import XHTML18_INDEX from '@/components/xhtml/18_Index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/04_Contents",
 			"name" : "xhtml/04_Contents",
 			"component" : XHTML04_CONTENTS
 		},
 		{
 			"path" : "/xhtml/05_Acknowledgments",
 			"name" : "xhtml/05_Acknowledgments",
 			"component" : XHTML05_ACKNOWLEDGMENTS
 		},
 		{
 			"path" : "/xhtml/06_Author_s_Notes",
 			"name" : "xhtml/06_Author_s_Notes",
 			"component" : XHTML06_AUTHOR_S_NOTES
 		},
 		{
 			"path" : "/xhtml/07_Introduction",
 			"name" : "xhtml/07_Introduction",
 			"component" : XHTML07_INTRODUCTION
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js